import type { Edge } from '@phi/jcore';
import { create_scene_node } from '@phi/util/object3d';
import { ref, shallowRef } from 'vue';

export const showing_curvature_combs = ref(false);

export const curvature_edges = shallowRef([] as Edge[]);

export const curvature_comb_scaling_factor = ref(1);

export type CurvatureCombNumber = 20 | 50 | 100 | 200;

export const number_of_curvature_combs = ref(50 as CurvatureCombNumber);

export const curvature_raynode = create_scene_node('uid_curvature_raynode');

export const showing_curvature_options_modal = ref(false);

export function show_curvature_options_modal() {
    showing_curvature_options_modal.value = true;
}

export function hide_curvature_options_modal() {
    showing_curvature_options_modal.value = false;
}
